
import styled from "styled-components";


export const FormContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const FormTitle = styled.h1`
  text-align: center;
  color: #333;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #555;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
`;

export const Button = styled.button`
  padding: 10px 15px;
  background-color: #00daff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #eef203;
  }
`;

export const RecommendationsContainer = styled.div`
   margin-top: 20px;
  padding: 20px;
  background-color: #e9ecef;
  border-radius: 8px;
  max-height: 600px; 
  overflow-y: auto; 

`;

export const RecommendationTitle = styled.h2`
  color: #333;
`;

export const RecommendationText = styled.p`
  color: #000;
  white-space: pre-wrap; 
`;
